import styled from '@emotion/styled';

import {
  color,
  border,
  space,
  typography,
  position,
  layout,
} from 'styled-system';
import { IconType } from 'components/Common/Icon';

export const StyledIcon = styled.i<IconType>`
  ${color};
  ${space};
  ${typography};
  ${position};
  ${layout};
  ${border};

  ::before {
    ${color};
  }

  outline: none;
  vertical-align: middle;

  span {
    vertical-align: middle;
  }

  ${({ theme, disabled }): string =>
    disabled &&
    `
      color: ${theme.colors.ash60} !important;
      : before {
        color: ${theme.colors.ash60} !important;
      }
  `}
`;

StyledIcon.defaultProps = {
  fontSize: '1rem',
};
